"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadJob = exports.UploadJobState = void 0;
var eventemitter3_1 = require("eventemitter3");
var file_descriptor_1 = require("../../../platform/management/metadata/file-descriptor");
var media_platform_1 = require("../../../types/media-platform/media-platform");
var upload_aborted_event_1 = require("./events/upload-aborted-event");
var upload_error_event_1 = require("./events/upload-error-event");
var upload_progress_event_1 = require("./events/upload-progress-event");
var upload_started_event_1 = require("./events/upload-started-event");
var upload_success_event_1 = require("./events/upload-success-event");
var upload_configuration_request_1 = require("../../../platform/management/requests/upload-configuration-request");
var UploadJobState;
(function (UploadJobState) {
    UploadJobState["STOPPED"] = "stopped";
    UploadJobState["RUNNING"] = "running";
})(UploadJobState = exports.UploadJobState || (exports.UploadJobState = {}));
/**
 * @param {string?} path
 * @param {File?} file
 * @param {UploadFileRequest?} uploadFileRequest
 * @constructor
 * @extends {EventEmitter}
 */
var UploadJob = /** @class */ (function (_super) {
    __extends(UploadJob, _super);
    function UploadJob(_a) {
        var file = _a.file, path = _a.path, uploadFileRequest = _a.uploadFileRequest, uploadUrl = _a.uploadUrl;
        var _this = _super.call(this) || this;
        _this.state = UploadJobState.STOPPED;
        _this.request = undefined;
        _this.file = file;
        _this.path = path;
        _this.uploadFileRequest = uploadFileRequest;
        _this.uploadUrl = uploadUrl;
        return _this;
    }
    /**
     * @param fileUploader
     * @returns {UploadJob}
     */
    UploadJob.prototype.run = function (fileUploader) {
        var _this = this;
        if (this.state === UploadJobState.RUNNING) {
            console.warn('job already running');
            return this;
        }
        if (!this.file) {
            throw Error('no file');
        }
        this.state = UploadJobState.RUNNING;
        var acl = media_platform_1.ACL.PUBLIC;
        if (this.uploadFileRequest && this.uploadFileRequest.acl) {
            acl = this.uploadFileRequest.acl;
        }
        var uploadStartedEvent = new upload_started_event_1.UploadStartedEvent(this);
        this.emit(uploadStartedEvent.name, uploadStartedEvent);
        var uploadConfiguration;
        if (this.uploadUrl) {
            uploadConfiguration = Promise.resolve({
                uploadUrl: this.uploadUrl,
            });
        }
        else {
            var uploadConfigurationRequest = new upload_configuration_request_1.UploadConfigurationRequest({
                acl: acl,
                mimeType: this.file.type,
                path: this.path,
                size: this.file.size,
            });
            uploadConfiguration = fileUploader.getUploadConfiguration(uploadConfigurationRequest);
        }
        uploadConfiguration.then(function (response) {
            var onProgress = function (event) {
                var e = new upload_progress_event_1.UploadProgressEvent(_this, event.loaded, event.total);
                _this.emit(e.name, e);
            };
            var onLoad = function (event) {
                var e;
                if (event.target.status >= 400) {
                    e = new upload_error_event_1.UploadErrorEvent(_this, event.target.response);
                }
                else {
                    var payload = typeof event.target.response === 'string'
                        ? JSON.parse(event.target.response).payload
                        : event.target.response.payload;
                    var fileDescriptors = [new file_descriptor_1.FileDescriptor(payload)];
                    e = new upload_success_event_1.UploadSuccessEvent(_this, event.target.response, fileDescriptors);
                }
                _this.emit(e.name, e);
            };
            var onError = function () {
                var e = new upload_error_event_1.UploadErrorEvent(_this, request.response);
                _this.emit(e.name, e);
            };
            var onAbort = function (event) {
                var e = new upload_aborted_event_1.UploadAbortedEvent(event.target);
                _this.emit(e.name, e);
            };
            var onLoadEnd = function () {
                reset();
                _this.emit('upload-end');
            };
            var reset = function () {
                if (request.upload) {
                    request.upload.removeEventListener('progress', onProgress);
                }
                else {
                    request.removeEventListener('progress', onProgress);
                }
                request.removeEventListener('load', onLoad);
                request.removeEventListener('error', onError);
                request.removeEventListener('abort', onAbort);
                request.removeEventListener('loadend', onLoadEnd);
                _this.state = UploadJobState.STOPPED;
            };
            var formData = new FormData();
            if (_this.path !== undefined) {
                formData.append('path', _this.path);
            }
            if (_this.file !== undefined) {
                formData.append('file', _this.file);
            }
            formData.append('acl', acl);
            if (_this.uploadFileRequest && _this.uploadFileRequest.lifecycle) {
                formData.append('lifecycle', _this.uploadFileRequest.lifecycle);
            }
            var request = (_this.request = new XMLHttpRequest());
            if (request.upload) {
                request.upload.addEventListener('progress', onProgress);
            }
            else {
                request.addEventListener('progress', onProgress);
            }
            request.addEventListener('load', onLoad);
            request.addEventListener('error', onError);
            request.addEventListener('abort', onAbort);
            request.addEventListener('loadend', onLoadEnd);
            request.open('POST', response.uploadUrl);
            request.withCredentials = true;
            request.responseType = 'json';
            request.send(formData);
        }, function (error) {
            var e = new upload_error_event_1.UploadErrorEvent(_this, error);
            _this.emit(e.name, e);
        });
        return this;
    };
    UploadJob.prototype.abort = function () {
        if (this.state !== UploadJobState.RUNNING) {
            throw Error('Job is not running');
        }
        if (this.request) {
            this.request.abort();
        }
    };
    return UploadJob;
}(eventemitter3_1.EventEmitter));
exports.UploadJob = UploadJob;
//# sourceMappingURL=upload-job.js.map